import { Button, Tooltip } from '@mui/material'
import React, { forwardRef } from 'react'

const CButton = forwardRef(({ title, children, onClick, size = 'medium', sx, ...props }, ref) => {
  return (
    <Tooltip title={title}>
      <Button
        onClick={onClick}
        aria-label={title}
        sx={{
          m: 0,
          minWidth: 'unset',
          width: '32px',
          height: '32px',
          padding: '0px',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: 'action.hover',
            border: 'none',
            // border: '1px solid',
            borderColor: 'primary.main',
          },
          '&:active': {
            transform: 'scale(0.95)',
            transition: 'transform 0.1s ease-in-out',
          },
          ...sx,
        }}
        size={size}
        ref={ref}
        {...props}
      >
        {children}
      </Button>
    </Tooltip>
  )
})

export default CButton
